
import users from '@/services/users';
import tenants from '@/services/tenants';
import stores from '@/services/stores';

export default {
  data() {
    return {
      isExistingContract: false,
      loading: false,
      hasContract: false,
      contractUrl: '',
      contractStartDate: null,
      contractEndDate: null,
      contractTerm: null,
      paymentTerm: null,
      contractAutoRenewal: null,

      contractOptions: [
        { title: '6 months' },
        { title: '1 year' },
        { title: '3 years' },
        { title: '5 years' },
        { title: 'N/A (No contract on file)' }
      ],
      paymentOptions: [{ title: 'Net 45' }, { title: 'Net 30' }],
      contractAutoRenewalOptions: [{ title: 'On' }, { title: 'Off' }]
    };
  },

  computed: {
    t() {
      return this.$store.state.user.translate;
    },
    admin() {
      let checkAdmin = this.$store.state?.user?.profile?.email.startsWith(
        'botadmin@'
      );
      return checkAdmin;
    },
    endDateOptions() {
      if (!this.contractStartDate) return () => true;
      return date => date >= this.contractStartDate;
    },

    isContractLocked() {
      return this.isExistingContract;
    }
  },

  mounted() {
    this.getUserDetails();
  },

  methods: {
    async uploadContract(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 25 * 1024 * 1024) {
        this.$q.notify({
          message: `${file.name} exceeds 25 MB limit`,
          color: 'red'
        });
        event.target.value = null;
        return;
      }

      try {
        this.loading = true;

        // upload file
        const response = await stores.uploadFiles(file);
        let uploadedFileMeta = {};
        try {
          uploadedFileMeta = await response.json();
          console.log('uploadedFileMeta', uploadedFileMeta);
        } catch {
          uploadedFileMeta = { url: null };
        }
        console.log('uploadedFileMeta', uploadedFileMeta);
        // ✅ backend should return URL or key
        this.contractUrl =
          uploadedFileMeta.response.Key ||
          uploadedFileMeta.response.url ||
          null;

        this.hasContract = true;
        console.log('this.contractUrl', this.contractUrl);
        this.$q.notify({
          message: this.t.updated_successfully,
          color: 'green'
        });
      } catch (err) {
        console.error(err);
        this.$q.notify({
          message: this.t.something_went_wrong,
          color: 'red'
        });
      } finally {
        this.loading = false;
        event.target.value = null;
      }
    },

    // viewContract() {
    //   if (!this.contractUrl) return;
    //   window.open(this.contractUrl, '_blank');
    // },
    async viewContract(contractUrl) {
      this.loading = true;
      const fileName = contractUrl.substring(contractUrl.lastIndexOf('/') + 1);
      console.log('fileName', fileName);
      try {
        const data = await stores.ApiGetImage(fileName);
        const url = data.response.url;
        if (!url) {
          this.$q.notify({ message: ' URL not available', color: 'red' });
          return;
        }

        // Option 1: open in new tab
        window.open(
          `https://docs.google.com/gview?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          '_blank'
        );

        // this.pdfUrl = url;
        // this.showViewDialog = true;
      } catch (err) {
        this.$q.notify({ message: err.message, color: 'red' });
      } finally {
        this.loading = false;
      }
    },
    async getUserDetails() {
      try {
        this.loading = true;
        const { data } = await users.getUserDetails();
        const tenant = data.response.userDetails.tenant || {};

        this.contractStartDate = tenant.contractStartDate || null;
        this.contractEndDate = tenant.contractEndDate || null;
        this.contractTerm = tenant.contractTerm || null;
        this.paymentTerm = tenant.paymentTerm || null;
        this.contractAutoRenewal = tenant.contractAutoRenewal || null;
        this.contractUrl = tenant.contractLink || null;

        // ✅ lock only if contract already exists
        this.isExistingContract = !!(
          tenant.contractStartDate && tenant.contractEndDate
        );
      } finally {
        this.loading = false;
      }
    },

    async savePlanDetails() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        this.$q.notify({
          message: 'Please fill all required fields',
          color: 'red'
        });
        return;
      }
      try {
        this.loading = true;
        let plainDetailsInfo = {
          contractStartDate: this.contractStartDate,
          contractEndDate: this.contractEndDate,
          contractTerm: this.contractTerm,
          paymentTerm: this.paymentTerm,
          contractAutoRenewal: this.contractAutoRenewal,
          contractUrl: this.contractUrl
        };
        await tenants.updateTenant(plainDetailsInfo);
        this.isExistingContract = true;
        this.$q.notify({
          message: this.t.updated_successfully,
          color: 'green'
        });
      } catch (e) {
        this.$q.notify({
          message: e?.response?.data?.message || this.t.something_went_wrong,
          color: 'red'
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
